import styled from "@emotion/styled";
import { Tabs as AntTabs } from "antd";
import { theme } from "Styles";

/** Ant Design Tabs styled to match legacy nav tabs; nav scrolls horizontally when it overflows. */
export const StyledNavTabs = styled(AntTabs)`
    .ant-tabs-nav {
        margin: 0 !important;
        padding: 0 20px;
        border-bottom: 1px solid #dee2e6;
    }

    .ant-tabs-nav::before {
        border-bottom: none;
    }

    /* rc-tabs: scrollable tab list */
    .ant-tabs-nav-wrap {
        flex: 1 1 auto;
    }

    .ant-tabs-nav-list {
        flex-wrap: nowrap;
    }

    .ant-tabs-tab {
        flex: 0 0 auto;
        align-items: center;
        background: ${theme.palette.tableHeader.light} !important;
        border: 1px solid #dee2e6 !important;
        border-bottom: none !important;
        border-radius: 0 !important;
        color: #040506 !important;
        font-size: 0.75rem;
        font-weight: 700;
        justify-content: center;
        margin: 2rem 0 0 -1px !important;
        min-height: 2rem;
        min-width: min(12rem, max(7rem, 28vw));
        padding: 0 12px !important;
        text-transform: uppercase;
        transition: margin-top 0.2s ease-in-out, color 0.2s ease-in-out, background 0.2s ease-in-out;
    }

    .ant-tabs-tab:first-of-type {
        margin-left: 0 !important;
    }

    .ant-tabs-tab-active {
        background: white !important;
        color: #20a8e7 !important;
        margin-bottom: -1px !important;
        margin-top: 0.5rem !important;
    }

    .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn {
        color: rgba(4, 5, 6, 0.35) !important;
        cursor: not-allowed;
    }

    .ant-tabs-tab-btn {
        color: inherit !important;
    }

    .ant-tabs-tab-btn:focus-visible {
        outline: 2px solid #20a8e7;
        outline-offset: 2px;
    }

    .ant-tabs-ink-bar {
        display: none;
    }

    .ant-tabs-content-holder {
        display: none;
    }
`;
